export let getEntityDefinition = ({ defs, entity }) => {
  return defs.find(x => x.id === entity);
};

export let getParentNames = ({ def }) => { // links and subgroup links
  return def.links.reduce((acc, val) => val.subgroup
    ? [ ...acc, ...val.subgroup.map(x => x.name) ]
    : [ ...acc, val.name ]
  , []);
};

export let getFields = ({ def }) => { // get all properties which are not links
  if (!def) return [];
  let keys = Object.keys(def.properties);
  let links = getParentNames({ def });
  return keys.filter(x => links.every(y => y !== x));
};

export let buildRelatedEntitiesQueries = ({ defs, entityType }) => {
  let filteredDefs = defs.filter(x =>
    x.links &&
    x.properties.submitter_id &&
    x.id !== entityType &&
    x.id !== 'program' &&
    x.id !== 'project' &&
    x.submittable
  );

  let queries = filteredDefs.map(x => `
    ${x.id}: _${x.id}_count(with_path_to: {type: "${entityType}", id: $id})
  `);

  return { filteredDefs, queries };
};

export let groupDefinitionsByCategory = ({ defs }) => {
  return defs.reduce((acc, def) => ({
    ...acc,
    [def.category]: [ ...(acc[def.category] || []), def ]
  }), {});
};

export let getSubmittableFileDefinitions = ({ defs }) => {
  return defs.filter(d => (d.category === 'metadata_file' || d.category === 'data_file') && d.submittable);
};
